import React, { useState } from "react"
import Modal from "react-bootstrap/Modal"
import { Formik, Form, Field, ErrorMessage } from "formik"
import * as Yup from "yup"
import axios from "axios"
import toArrayBuffer from "to-array-buffer";
import { API_CONSTANTS } from "../../../../../API_CONSTANTS"
import CloseIcon from "@mui/icons-material/Close"
import Toast from '../../../../../Components/Toast/Toast'
import Spinner from "react-bootstrap/Spinner"
import {
  faCheckCircle,
  faTimesCircle,
} from '@fortawesome/fontawesome-free-solid'
import ReactTagInput from '@pathofdev/react-tag-input'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { useSelector } from "react-redux"
import { useParams } from "react-router"

export default function AddMember() {
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const [isLoading, setIsLoading] = useState(false)
  const [validDurationSpan, setValidDurationSpan] = useState("")
  const [planCategory, setPlanCategory] = useState("")
  // const [planType, setPlanType] = useState("")
  const [ToastMessage, setToastMessage] = useState('')
  const [showToast, setShowToast] = useState('')
  const [ToastIcon, setToastIcon] = useState(faTimesCircle)
  const [iconColor, setIconColor] = useState('')
  const [includes, setIncludes] = useState([])
  const [selectedSpecialization, setSelectedSpecialization] = useState("")
  const [specializationRows, setSpecializationRows] = useState([])
  const [planImage, setPlanImage] = useState(null)
  const [planImagePreview, setPlanImagePreview] = useState("")
  const params = useParams();
  const {loading, value} = useSelector((state) => state.getDataReducer)

  // Handle image upload
  const handleImageUpload = (e) => {
    const file = e.target.files[0]
    if (file) {
      setPlanImage(file)
      const reader = new FileReader()
      reader.onloadend = () => {
        setPlanImagePreview(reader.result)
      }
      reader.readAsDataURL(file)
    }
  }

  // Remove image
  const handleRemoveImage = () => {
    setPlanImage(null)
    setPlanImagePreview("")
  }

  // Toast Message 
  const handleToast = (message, icon, iconColor, className) => {
    setToastIcon(icon)
    setToastMessage(message)
    setShowToast(`show ${className}`)
    setIconColor(iconColor)
    setTimeout(() => setShowToast(''), 2900)
  }

  // Add specialization row
  const handleAddSpecialization = (specId) => {
    if (specId && !specializationRows.find(row => row.id === specId)) {
      setSpecializationRows([
        ...specializationRows,
        {
          id: specId,
          discount: '',
          noOfCalls: '',
          subscriptionPlan: ''
        }
      ])
      setSelectedSpecialization("")
    }
  }

  // Remove specialization row
  const handleRemoveSpecialization = (specId) => {
    setSpecializationRows(specializationRows.filter(row => row.id !== specId))
  }

  // Update specialization row data
  const handleUpdateRow = (specId, field, value) => {
    setSpecializationRows(specializationRows.map(row => 
      row.id === specId ? { ...row, [field]: value } : row
    ))
  }

  // Initial Values for Add subscription Form
  const initialValues = {
    planStatus: "active",
    termsAndConditions: "",
    charges: "",
    subscriptionName: "",
    subHeading: "",
    validDuration: "",
    saveRupees: "",
  };

  // Validation of Form 
  const validationSchema = Yup.object({
    planStatus: Yup.string().required('Plan status is required'),
    termsAndConditions: Yup.string().required('Terms and conditions are required'),
    charges: Yup.number().min(1, 'Charges must be greater than 0').required('Charges are required'),
    subscriptionName: Yup.string().required('Subscription name is required'),
    subHeading: Yup.string().required('Sub heading is required'),
    validDuration: Yup.number().min(1, 'Valid duration must be greater than 0').required('Valid duration is required'),
    saveRupees: Yup.number().required('Save rupees value is required'),
  })

   // upload img api call function.
    const callApi = async (imgBuffer) => {
      // console.log(imgBuffer);
      let apiData;
  
      const data = imgBuffer;
      await axios
        .post(
          `${API_CONSTANTS.BASEURL}admin/image-upload-api/user/${params.id}/type/new`,
          data,
          {
            headers: API_CONSTANTS.imgheaders(),
          }
        )
        .then((r) => {
          apiData = r.data.response.url; 
          // console.log(' [IMAGE URL]', r.data.response.url);
        })
        .catch((e) => {
          //console.error(' [IMAGE UPLOAD ERROR]', e.response?.data || e.message);
        });
  
      return apiData;
    };

  // API integration of Add subscription Form 
  const handleSubmit = async (values, { setSubmitting }) => {
   // console.log(' [SUBMIT START] handleSubmit called with values:', values);
    setIsLoading(true);
    
    // Validate planImage
    if (!planImage) {
      //console.warn(' [VALIDATION] Plan image is missing');
      handleToast(
        'Please select a Plan Image',
        faTimesCircle,
        '#dc3545',
        'show-error'
      )
      setIsLoading(false);
      setSubmitting(false);
      return;
    }
    
    //console.log(' [VALIDATION] Plan image validated:', planImage.name);
    
    // Validate planType
    // if (!planType) {
    //   console.warn(' [VALIDATION] Plan type is missing');
    //   handleToast(
    //     'Please select a Plan Type',
    //     faTimesCircle,
    //     '#dc3545',
    //     'show-error'
    //   )
    //   setIsLoading(false);
    //   setSubmitting(false);
    //   return;
    // }
    
    // console.log(' [VALIDATION] Plan type validated:', planType);
    
    // Validate specializations
    if (specializationRows.length === 0) {
      //console.warn(' [VALIDATION] At least one specialization is required');
      handleToast(
        'Please add at least one specialization',
        faTimesCircle,
        '#dc3545',
        'show-error'
      )
      setIsLoading(false);
      setSubmitting(false);
      return;
    }
    
    // Validate that all specializations have a plan type selected
    const invalidSpecializations = specializationRows.filter(row => !row.subscriptionPlan);
    if (invalidSpecializations.length > 0) {
     // console.warn(' [VALIDATION] All specializations must have a plan type selected');
      handleToast(
        'Please select a plan type for all specializations',
        faTimesCircle,
        '#dc3545',
        'show-error'
      )
      setIsLoading(false);
      setSubmitting(false);
      return;
    }
    
    //console.log(' [VALIDATION] Specializations validated:', specializationRows.length);
    
    // Validate validDurationSpan (state-managed field)
    if (!validDurationSpan) {
     // console.warn(' [VALIDATION] Valid duration span is missing');
      handleToast(
        'Please select a duration span',
        faTimesCircle,
        '#dc3545',
        'show-error'
      )
      setIsLoading(false);
      setSubmitting(false);
      return;
    }
    
    //console.log(' [VALIDATION] Duration span validated:', validDurationSpan);
    
    // Validate planCategory (state-managed field)
    if (!planCategory) {
      //console.warn(' [VALIDATION] Plan category is missing');
      handleToast(
        'Please select a plan category',
        faTimesCircle,
        '#dc3545',
        'show-error'
      )
      setIsLoading(false);
      setSubmitting(false);
      return;
    }
    
    //console.log(' [VALIDATION] Plan category validated:', planCategory);
    
    // Validate includes (state-managed field)
    if (!includes || includes.length === 0) {
     // console.warn(' [VALIDATION] At least one include item is required');
      handleToast(
        'Please add at least one include item',
        faTimesCircle,
        '#dc3545',
        'show-error'
      )
      setIsLoading(false);
      setSubmitting(false);
      return;
    }
    
    //console.log(' [VALIDATION] Includes validated:', includes.length);
    
    // Transform specializations to new format
    const transformedSpecializations = specializationRows.map(spec => ({
      name: spec.id,
      type: spec.subscriptionPlan === 'no_of_calls' ? 'calls' : spec.subscriptionPlan,
      calls: spec.subscriptionPlan === 'discount' ? null : (spec.subscriptionPlan === 'no_of_calls' ? spec.noOfCalls : 'unlimited'),
      discount: spec.subscriptionPlan === 'discount' ? parseFloat(spec.discount) : null
    }));

    //console.log(' [SPECIALIZATION TRANSFORM]:', JSON.stringify(transformedSpecializations, null, 2));

    // Build JSON data object
    const jsonData = {
      subscriptionName: values.subscriptionName,
      sub_heading: values.subHeading,
      saveRupees: parseFloat(values.saveRupees),
      charges: parseFloat(values.charges),
      specializations: transformedSpecializations,
      validDuration: parseInt(values.validDuration),
      validDurationSpan: validDurationSpan,
      // planType: planType,
      planCategory: planCategory,
      planStatus: values.planStatus,
      includes: includes,
      termsAndConditions: values.termsAndConditions,
      url: null // Will be populated if image exists
    };
 
    // console.log(' [JSON DATA] Initial JSON data created');
    // console.log('  - subscriptionName:', jsonData.subscriptionName);
    // console.log('  - subHeading:', jsonData['sub_heading']);
    // console.log('  - charges:', jsonData.charges);
    // console.log('  - saveRupees:', jsonData.saveRupees);
    // console.log('  - validDuration:', jsonData.validDuration);
    // console.log('  - validDurationSpan:', jsonData.validDurationSpan);
    // console.log('  - planType:', jsonData.planType);
    // console.log('  - planCategory:', jsonData.planCategory);
    // console.log('  - planStatus:', jsonData.planStatus);
    // console.log('  - includes count:', jsonData.includes.length);
    // console.log('  - termsAndConditions length:', jsonData.termsAndConditions.length);
    // console.log('  - specializationRows count:', jsonData.specializations.length);
    // console.log(' [FULL JSON]:', JSON.stringify(jsonData, null, 2));
    
    // Handle image upload if present
    if (planImage) {
     // console.log(' [IMAGE] Processing image:', planImage.name, 'Size:', planImage.size);
      
      try {
        const reader = new FileReader();
        
        reader.onload = async () => {
        //  console.log('[READER] FileReader onload triggered');
          try {
            const fileRes = btoa(reader.result);
           // console.log(' [IMAGE] Base64 conversion completed, length:', fileRes.length);
            
            const testImg = toArrayBuffer(fileRes);
           // console.log(' [IMAGE] Array buffer conversion completed');
            
            console.log(' [API CALL] Calling image upload API...');
            let imgURL = await callApi(testImg);
           // console.log(' [IMAGE URL] Received image URL:', imgURL);
            
            jsonData.url = imgURL;
          //  console.log('[JSON DATA] Image URL added to JSON data');
            
            // Now send the complete JSON with image
            await sendJsonData(jsonData);
          } catch (imageError) {
           // console.error(' [IMAGE ERROR]', imageError);
            handleToast(
              'Error processing image',
              faTimesCircle,
              '#dc3545',
              'show-error'
            );
            setIsLoading(false);
            setSubmitting(false);
          }
        };
        
        reader.onerror = (error) => {
         // console.error(' [READER ERROR]', error);
          handleToast(
            'Error reading image file',
            faTimesCircle,
            '#dc3545',
            'show-error'
          );
          setIsLoading(false);
          setSubmitting(false);
        };
        
       // console.log(' [IMAGE] Starting binary string read...');
        reader.readAsBinaryString(planImage);
      } catch (error) {
       // console.error(' [IMAGE PROCESSING ERROR]', error);
        handleToast(
          'Error preparing image',
          faTimesCircle,
          '#dc3545',
          'show-error'
        );
        setIsLoading(false);
        setSubmitting(false);
      }
    } else {
      //console.log('ℹ [NO IMAGE] No image provided, sending JSON data as is');
      // No image, send JSON data immediately
      await sendJsonData(jsonData);
    }
    
    // Helper function to send JSON data
    async function sendJsonData(data) {
      // console.log(' [AXIOS] Sending POST request to:', `${API_CONSTANTS.BASEURL_1}admin/subscriptionplan`);
      // console.log(' [JSON PAYLOAD]:', JSON.stringify(data, null, 2));
      
      axios
        .post(`${API_CONSTANTS.BASEURL_1}admin/subscriptionplan`, data, {
          headers: {
            ...API_CONSTANTS.headers(),
            'Content-Type': 'application/json'
          },
        })
        .then((response) => {
          // console.log(' [RESPONSE SUCCESS]', response.data);
          if (response.data.message === 'Success') {
           
            handleToast(
              'Subscription Plan added Successfully',
              faCheckCircle,
              '#009b94',
              'show-success'
            )
          }
          handleClose();
        })
        .catch((error) => {
       
          handleToast(
            'Something went wrong',
            faTimesCircle,
            '#dc3545',
            'show-error'
          );
        })
        .finally(() => {
          setIsLoading(false)
          setSubmitting(false)
        });
    }
  };

  return (
    <>
      <button className="add-record btn mx-4 mt-4" onClick={handleShow}>
        <i className="fas fa-plus" style={{ marginRight: 8 }}></i>
        Add New Plan
      </button>

      <Modal show={show} size="lg">
        <Modal.Body className="d-flex flex-column">
          <div className="d-flex justify-content-between">
            <h4>Add New Plan</h4>
            <CloseIcon onClick={handleClose} style={{ cursor: "pointer" }} />
          </div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            <Form className="form-inline row g-3">
              <div className="col-md-6 mb-4">
                <Field
                  type="text"
                  name="subscriptionName"
                  placeholder="Plan Name"
                  className="form-control border-0 border-bottom"
                />
                <ErrorMessage
                  name="subscriptionName"
                  component="div"
                  className="error-message"
                />
              </div>
              <div className="col-md-6 mb-4">
                <Field
                  type="text"
                  name="subHeading"
                  placeholder="Sub Heading (Short Description)"
                  className="form-control border-0 border-bottom"
                />
                <ErrorMessage
                  name="subHeading"
                  component="div"
                  className="error-message"
                />
              </div>
             
              <div className="col-md-6">
                <Field
                  type="number"
                  name="saveRupees"
                  placeholder="Save Rupees"
                  className="form-control border-0 border-bottom"
                />
                <ErrorMessage
                  name="saveRupees"
                  component="div"
                  className="error-message"
                />
              </div>
              <div className="col-md-6">
                <Field
                  type="number"
                  name="charges"
                  placeholder="Price In Rupees"
                  className="form-control border-0 border-bottom"
                />
                <ErrorMessage
                  name="charges"
                  component="div"
                  className="error-message"
                />
              </div>

              {/* Plan Image Upload Section */}
              <div className="col-md-12 mt-4">
                <label className="form-label" style={{
                  fontSize: '1rem',
                  fontWeight: '500'
                }}>
                  Plan Image
                </label>
                <div className="image-upload-container">
                  <input
                    type="file"
                    id="planImageInput"
                    accept="image/*"
                    onChange={handleImageUpload}
                    style={{ display: 'none' }}
                  />
                  {!planImagePreview ? (
                    <label htmlFor="planImageInput" className="upload-label">
                      <div className="upload-box">
                        <i className="fas fa-cloud-upload-alt upload-icon"></i>
                        <p className="upload-text">Click to upload image</p>
                        <p className="upload-subtext">PNG, JPG, JPEG (Max 5MB)</p>
                      </div>
                    </label>
                  ) : (
                    <div className="image-preview-container">
                      <img src={planImagePreview} alt="Plan preview" className="preview-image" />
                      <div className="image-info">
                        <p className="image-name">
                          <i className="fas fa-image"></i> {planImage?.name}
                        </p>
                        <button
                          type="button"
                          className="btn btn-sm btn-remove-image"
                          onClick={handleRemoveImage}
                        >
                          <i className="fas fa-times"></i> Remove
                        </button>
                      </div>
                    </div>
                  )}
                </div>
                {!planImage && (
                  <div className="error-message" style={{ marginTop: '10px' }}>
                    <i className="fas fa-exclamation-circle" style={{ marginRight: '5px' }}></i>
                    Plan image is required
                  </div>
                )}
              </div>

              {/* Specialization Selection Section */}
              <div className="col-md-12 mt-4">
                <label className="form-label" style={{
                  marginTop: '10px',
                  fontSize: '1rem',
                  fontWeight: '500'
                }}>
                  Select Specializations
                </label>
                <div className="position-relative">
                  <select
                    className="form-control border-0 border-bottom"
                    value={selectedSpecialization}
                    onChange={(e) => handleAddSpecialization(e.target.value)}
                  >
                    <option value="">Choose Specialization</option>
                    {value && value.Specializations && value.Specializations.length > 0
                      ? value.Specializations
                          .filter((s) => !specializationRows.find(row => row.id === s.Id))
                          .map((s) => (
                            <option key={s.Id} value={s.Id}>
                              {s.Id}
                            </option>
                          ))
                      : <option disabled>Loading specializations...</option>
                    }
                  </select>
                  <FontAwesomeIcon icon={faChevronDown} className="dropdown-icon-absolute" />
                </div>
              </div>

              {/* Dynamic Specialization Rows */}
              {specializationRows.length > 0 && (
                <div className="col-md-12 mt-3">
                  <label className="form-label" style={{
                    fontSize: '1rem',
                    fontWeight: '500',
                    marginBottom: '15px'
                  }}>
                    Specialization Prices
                  </label>
                  {specializationRows.map((row, index) => (
                    <div key={row.id} className="mb-3 specialization-row">
                      <div className="row align-items-center">
                        <div className="col-md-3">
                          <div className="spec-label">{row.id}</div>
                        </div>
                        <div className="col-md-7 position-relative">
                          <select
                            className="form-control border-0 border-bottom"
                            value={row.subscriptionPlan}
                            onChange={(e) => handleUpdateRow(row.id, 'subscriptionPlan', e.target.value)}
                          >
                            <option value="">Select Plan</option>
                            <option value="unlimited">Unlimited</option>
                            <option value="discount">Discount</option>
                            <option value="no_of_calls">No of Calls</option>
                          </select>
                          <FontAwesomeIcon icon={faChevronDown} className="dropdown-icon-absolute" />
                        </div>
                        <div className="col-md-2 text-end">
                          <button
                            type="button"
                            className="btn btn-danger btn-sm"
                            onClick={() => handleRemoveSpecialization(row.id)}
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </div>
                      </div>
                      
                      {/* Conditional Fields based on Plan Selection */}
                      {row.subscriptionPlan === 'discount' && (
                        <div className="row mt-3">
                          <div className="col-md-3"></div>
                          <div className="col-md-9">
                            <input
                              type="number"
                              className="form-control border-0 border-bottom"
                              placeholder="Discount Percentage (1-100)"
                              value={row.discount}
                              onChange={(e) => handleUpdateRow(row.id, 'discount', e.target.value)}
                            />
                          </div>
                        </div>
                      )}
                      
                      {row.subscriptionPlan === 'no_of_calls' && (
                        <div className="row mt-3">
                          <div className="col-md-3"></div>
                          <div className="col-md-9">
                            <input
                              type="number"
                              className="form-control border-0 border-bottom"
                              placeholder="Number of Calls"
                              value={row.noOfCalls}
                              onChange={(e) => handleUpdateRow(row.id, 'noOfCalls', e.target.value)}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
              {specializationRows.length === 0 && (
                <div className="col-md-12">
                  <div className="error-message" style={{ marginTop: '10px' }}>
                    <i className="fas fa-exclamation-circle" style={{ marginRight: '5px' }}></i>
                    At least one specialization is required
                  </div>
                </div>
              )}

              {/* Validate that all specializations have plan type selected */}
              {specializationRows.length > 0 && specializationRows.some(row => !row.subscriptionPlan) && (
                <div className="col-md-12">
                  <div className="error-message" style={{ marginTop: '10px' }}>
                    <i className="fas fa-exclamation-circle" style={{ marginRight: '5px' }}></i>
                    Please select a plan type for all specializations
                  </div>
                </div>
              )}

              <p style={{
                marginBottom: '0px',
                marginTop: '20px',
                fontSize: '1rem',
                fontWeight: '500'
              }}>
                Duration
              </p>
              <div className="col-md-6 mb-4">
                <Field
                  type="number"
                  name="validDuration"
                  placeholder="Duration in Number"
                  className="form-control border-0 border-bottom"
                />
                <ErrorMessage
                  name="validDuration"
                  component="div"
                  className="error-message"
                />
              </div>
              <div className="col-md-6 position-relative">
                <select
                  className="form-control border-0 border-bottom"
                  name="validDurationSpan"
                  value={validDurationSpan}
                  onChange={(e) => setValidDurationSpan(e.target.value)}
                >
                  <option value="">Choose One Duration</option>
                  <option value="weeks">Weeks</option>
                  <option value="days">Days</option>
                  <option value="months">Months</option>
                  <option value="years">Yearly</option>
                </select>
                <FontAwesomeIcon icon={faChevronDown} className="dropdown-icon-absolute" />
              </div>
               {/* <div className="col-md-6 position-relative">
                <select
                  className="form-control border-0 border-bottom"
                  name="planType"
                  value={planType}
                  onChange={(e) => setPlanType(e.target.value)}
                >
                  <option value="">Select Plan Type</option>
                  <option value="individual">Individual</option>
                  <option value="family">Family</option>
                </select>
                <FontAwesomeIcon icon={faChevronDown} className="dropdown-icon-absolute" />
              </div> */}
              <div className="col-md-6 position-relative">
                <select
                  className="form-control border-0 border-bottom"
                  name="planCategory"
                  value={planCategory}
                  onChange={(e) => setPlanCategory(e.target.value)}
                >
                  <option value="">Choose Plan Category</option>
                  <option value="Weekly">Weekly</option>
                  <option value="2 weeks">2 Weeks</option>
                  <option value="3 weeks">3 Weeks</option>
                  <option value="Monthly">Monthly</option>
                  <option value="3 months">3 Months</option>
                  <option value="6 months">6 Months</option>
                  <option value="Yearly">Yearly</option>
                </select>
                <FontAwesomeIcon icon={faChevronDown} className="dropdown-icon-absolute" />
              </div>

              <div className="col-md-12 mt-3">
                <label className="form-label" style={{
                  fontSize: '1rem',
                  fontWeight: '500'
                }}>
                  What It Includes
                </label>
                <ReactTagInput
                  tags={includes.length < 1 ? [] : includes}
                  placeholder={`Hit Enter to type the next lines`}
                  editable={true}
                  name='includes'
                  value={includes}
                  removeOnBackspace={true}
                  onChange={(e) => {
                    setIncludes(e)
                  }}
                  validateOnChange={true}
                />
              </div>
              <div className="col-md-12">
                <label className="form-label" style={{
                  fontSize: '1rem',
                  fontWeight: '500'
                }}>
                  Terms and Conditions
                </label>
                <Field
                  type="text"
                  name="termsAndConditions"
                  placeholder="All Terms and Conditions here"
                  className="form-control"
                  as="textarea"
                />
                <ErrorMessage
                  name="termsAndConditions"
                  component="div"
                  className="error-message"
                />
              </div>
              <div className="row d-flex justify-content-center mt-5 mb-3 gap-3">
                <div className="col-md-5">
                  <button type="submit" className="btn btn-save w-100">
                    Save Changes{" "}
                    {isLoading && <Spinner animation="border" size="sm" />}
                  </button>
                </div>
                <div className="col-md-5">
                  <button
                    type="reset"
                    className="btn btn-outline-danger w-100"
                    onClick={handleClose}
                    style={{ height: "43px" }}
                  >
                    Discard Changes
                  </button>
                </div>
              </div>
            </Form>
          </Formik>
        </Modal.Body>
      </Modal>
      <style jsx="true">
        {`
          .btn-save:hover {
            background: #009b94 !important;
            color: #fff;
          }
          .error-message {
            color: red;
            font-size: 0.875rem;
            margin-top: 5px;
          }
          .dropdown-icon-absolute {
            position: absolute;
            top: 50%;
            right: 15px;
            transform: translateY(-50%);
            pointer-events: none;
          }
          .add-record {
            background: #009b94 !important;
            color: #fff;
          }
          .add-record:hover {
            background: #fff !important;
            color: #009b94 !important;
          }
          .react-tag-input:hover{
            border-color: #009b94 !important;
          }
          .react-tag-input__tag__remove{
            background: none !important;
          }
          .react-tag-input__tag__remove::before{
            background-color: #009b94 !important;
          }
          .react-tag-input__tag__remove::after{
            background-color: #009b94 !important;
          }
          .specialization-row {
            background: #f8f9fa;
            padding: 15px;
            border-radius: 8px;
            border-left: 3px solid #009b94;
          }
          .spec-label {
            font-weight: 600;
            color: #009b94;
            padding: 10px 0;
            font-size: 0.95rem;
          }
          .btn-danger {
            background-color: #dc3545;
            border: none;
          }
          .btn-danger:hover {
            background-color: #c82333;
          }
          .image-upload-container {
            margin-top: 10px;
          }
          .upload-label {
            cursor: pointer;
            display: block;
            margin-bottom: 0;
          }
          .upload-box {
            border: 2px dashed #009b94;
            border-radius: 8px;
            padding: 40px 20px;
            text-align: center;
            background: #f8f9fa;
            transition: all 0.3s ease;
          }
          .upload-box:hover {
            background: #e9ecef;
            border-color: #007d77;
          }
          .upload-icon {
            font-size: 3rem;
            color: #009b94;
            margin-bottom: 10px;
          }
          .upload-text {
            font-size: 1rem;
            font-weight: 500;
            color: #333;
            margin-bottom: 5px;
          }
          .upload-subtext {
            font-size: 0.875rem;
            color: #6c757d;
            margin-bottom: 0;
          }
          .image-preview-container {
            border: 2px solid #009b94;
            border-radius: 8px;
            padding: 15px;
            background: #f8f9fa;
          }
          .preview-image {
            width: 100%;
            max-height: 200px;
            object-fit: contain;
            border-radius: 5px;
            margin-bottom: 15px;
            background: white;
          }
          .image-info {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            gap: 10px;
          }
          .image-name {
            font-size: 0.9rem;
            color: #333;
            font-weight: 500;
            margin-bottom: 0;
            display: flex;
            align-items: center;
            gap: 8px;
          }
          .image-name i {
            color: #009b94;
          }
          .btn-remove-image {
            background-color: #dc3545;
            color: white;
            border: none;
            padding: 5px 15px;
            border-radius: 5px;
            font-size: 0.875rem;
          }
          .btn-remove-image:hover {
            background-color: #c82333;
            color: white;
          }
        `}
      </style>
      <Toast
        cName={showToast}
        icon={ToastIcon}
        color={iconColor}
        text={ToastMessage}
      />
    </>
  );
}